import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lohi-confirm-action-dialog',
  templateUrl: './confirm-action-dialog.component.html',
  styleUrls: [],
})
export class ConfirmActionDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmActionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  public ngOnInit() {}
}
